import { render, staticRenderFns } from "./bottom-center.vue?vue&type=template&id=46fa923e&"
import script from "./bottom-center.vue?vue&type=script&lang=js&"
export * from "./bottom-center.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports